import {Directive, ElementRef, Input, OnChanges} from '@angular/core';
import {UserPreferencesService} from '../service/user-preferences.service';
import Color from 'color';
@Directive({
  selector: '[appBg]'
})
export class BgDirective implements OnChanges {

  @Input() appBg: string;
  @Input() brightness: string;

  constructor(private el: ElementRef, private userPreferencesService: UserPreferencesService) {}

  ngOnChanges() {
    if (this.appBg !== 'none') {
      let c = (this.appBg === 'primary') ? this.userPreferencesService.getPrimaryColor() : this.userPreferencesService.getSecondaryColor();
      switch (this.brightness) {
        case 'light':
          c = Color(c).lighten(0.2);
          break;
        case 'lighter':
          c = Color(c).lighten(0.4);
          break;
        case 'lightest':
          c = Color(c).fade(0.8);
          break;
        case 'dark':
          c = Color(c).darken(0.2);
          break;
        case 'darker':
          c = Color(c).darken(0.4);
          break;
      }
      this.el.nativeElement.style.backgroundColor = c;
    } else {
      this.el.nativeElement.style.backgroundColor = 'unset';
    }
    this.el.nativeElement.style.color = (this.appBg === 'primary') ? this.userPreferencesService.getPrimaryTextColor() :
      this.userPreferencesService.getSecondaryTextColor();
  }
}
